import { useAsync } from 'react-async'
import { fetchUser } from '@/src/ck'
import styles from './Nav.module.css'
import DarkMode from '@/components/DarkMode'
// https://autocomplete-experimental.netlify.app/docs/docsearch/
import { DocSearch } from '@docsearch/react'
import '@docsearch/css'

function Nav() {
  function NavButton() {
    const { data } = useAsync(fetchUser)
    if (data) {
      const { user } = data

      if (user.isAuthenticated()) {
        const name = user.getName()
        const title = name ? `Log out ${name}` : ''
        const dataCy = name ? 'log-out' : 'log-in'
        return (
          <button
            className={styles.AuthButton}
            onClick={user.logoutRedirect}
            title={title}
            data-cy={dataCy}
          >
            Log out
          </button>
        )
      } else {
        return (
          <button className={styles.AuthButton} onClick={user.loginRedirect}>
            Log in
          </button>
        )
      }
    } else {
      return <div />
    }
  }
  return (
    <nav className={styles.Nav}>
      <NavButton />
      <DocSearch
        appId="1I3QBVLHX8"
        apiKey="ba4903b3be1708cde94afd6436ed739d"
        indexName="cypress_courses"
        placeholder="Search my Cypress courses"
      />
      <DarkMode />
    </nav>
  )
}

export default Nav
